import React, { useCallback } from "react";
import classNames from "classnames";
import { Form } from "react-bootstrap";
import { noop } from "lodash";

import { InputPropTypes } from "../../../propTypes";
import "./styles.scss";

const TextInput = ({
  label,
  disabled,
  readonly,
  input,
  rounded,
  multiline,
  className,
  error,
  onChange,
  onBlur,
  value,
  inputRef,
  autoFocus,
  ...inputProps
}) => {
  const onInputChange = useCallback(
    event => {
      const onChangeFn = input?.onChange || onChange;
      onChangeFn(event.target.value);
    },
    [input, onChange]
  );

  const onInputBlur = useCallback(
    event => {
      const trimmedValue = event.target.value.trim();
      const onBlurFn = input?.onBlur || onBlur;
      onBlurFn(trimmedValue);
    },
    [input, onBlur]
  );

  return (
    <Form.Control
      as={multiline ? "textarea" : "input"}
      // Workaround to disable default form autocomplete
      autoComplete="new-password"
      ref={inputRef}
      {...inputProps}
      {...input}
      disabled={disabled || readonly}
      readOnly={readonly}
      onDrop={e => e.preventDefault()}
      className={classNames(
        "mydpd-input mydpd-form-control",
        rounded && "rounded",
        className
      )}
      onChange={onInputChange}
      onBlur={onInputBlur}
      value={value}
      autoFocus={autoFocus}
    />
  );
};

TextInput.defaultProps = {
  multiline: false,
  type: "text",
  input: {},
  onChange: noop,
  onBlur: noop,
};

TextInput.propTypes = InputPropTypes;

export default TextInput;
